import { TableBody as MuiTableBody, withStyles, TableRow } from '@material-ui/core';
import { renderCell } from '../utils/PrintTableRendererUtils';

const styles = (theme) => ({
  tableRow: {
    pageBreakInside: 'avoid', 
    height: 'auto',
  }
});

const TableBody = ({ classes, rowData = [], columns = [] }) => (
  <MuiTableBody>
    {rowData.map((row, idx) => (
      <TableRow key={row.id || idx} className={classes.tableRow}>
        {columns.map((col) => renderCell(row, col))}
      </TableRow>
    ))}
  </MuiTableBody>
);

export default withStyles(styles)(TableBody);
